import { myGet, myPost, handleGetError, handlePostError } from '../utils/myAxios'
import { servAddr } from '../servAddr'

export function fetchComprights() {
  return dispatch => {
    myGet(dispatch, servAddr + 'compright').then((response) => {
      dispatch({type: "FETCH_COMPRIGHTS", payload: response.data.comprights});
    }, err => {
      handleGetError(dispatch, err);
    })
  }
}

export function editCompright(data, cb = () => {}) {
  return dispatch => {
    myPost(dispatch, servAddr + 'compright', {data}).then((response) => {
      cb();
      dispatch({type: "EDIT_COMPRIGHT", payload: data});
    }, err => {
      handlePostError(dispatch, err, cb);
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/comprightActions.js